export var colorGrey90 = '#050505';
export var colorGrey80 = '#262626';
export var colorGrey70 = '#333333';
export var colorGrey60 = '#525252';
export var colorGrey50 = '#717171';
export var colorGrey40 = '#8d8d8d';
export var colorGrey30 = '#a7a7a7';
export var colorGrey20 = '#c6c6c6';
export var colorGrey10 = '#dcdcdc';
export var colorGrey05 = '#f7f7f7';
export var colorGrey01 = '#fcfcfc';
export var colorGrey00 = '#ffffff';
export var colorBlue90 = '#0a39b7';
export var colorBlue80 = '#124ac2';
export var colorBlue70 = '#0042a5';
export var colorBlue60 = '#0b53bf';
export var colorBlue50 = '#1f67d3';
export var colorBlue40 = '#417fda';
export var colorBlue30 = '#6295e0';
export var colorBlue20 = '#92baf6';
export var colorBlue10 = '#bbd1f2';
export var colorBlue05 = '#e3eefd';
export var colorTurquoise90 = '#008f77';
export var colorTurquoise80 = '#00ad96';
export var colorTurquoise70 = '#00bca9';
export var colorTurquoise60 = '#6cd0c2';
export var colorTurquoise50 = '#00ad96';
export var colorTurquoise40 = '#26b9a6';
export var colorTurquoise30 = '#4cc6b6';
export var colorTurquoise20 = '#80d6cb';
export var colorTurquoise10 = '#b4e6e0';
export var colorTurquoise05 = '#e1f5f2';
export var colorYellow90 = '#ec9800';
export var colorYellow80 = '#efa600';
export var colorYellow70 = '#f1ae00';
export var colorYellow60 = '#f4bd00';
export var colorYellow50 = '#f3bd02';
export var colorYellow40 = '#f5c825';
export var colorYellow30 = '#f7d14d';
export var colorYellow20 = '#fade80';
export var colorYellow10 = '#ffecb3';
export var colorYellow05 = '#fef7e0';
export var colorGreen90 = '#64b72c';
export var colorGreen80 = '#76c23d';
export var colorGreen70 = '#7fc847';
export var colorGreen60 = '#93d357';
export var colorGreen50 = '#93d357';
export var colorGreen40 = '#a3da70';
export var colorGreen30 = '#b3e088';
export var colorGreen20 = '#c9e9ab';
export var colorGreen10 = '#d8f9ba';
export var colorGreen05 = '#f2faeb';
export var colorRed90 = '#c82a32';
export var colorRed80 = '#d1323a';
export var colorRed70 = '#c82a32';
export var colorRed60 = '#d73d45';
export var colorRed50 = '#e44b52';
export var colorRed40 = '#e8656c';
export var colorRed30 = '#ec8086';
export var colorRed20 = '#f2a5a9';
export var colorRed10 = '#fdd5d7';
export var colorRed05 = '#fce9ea';